import { Injectable } from '@angular/core';
import { HomeworkActivityQuery } from '@examdojo/homework';
import { map } from 'rxjs';
import { QuestionProgressDataSource } from '@examdojo/question';

@Injectable()
export class HomeworkQuestionProgressDataSource implements QuestionProgressDataSource {
  constructor(private readonly homeworkActivityQuery: HomeworkActivityQuery) {}

  readonly progressPct$ = this.homeworkActivityQuery.progress$.pipe(
    map((progress) => {
      if (!progress) {
        return null;
      }

      if (progress.totalMarks === 0) {
        return 0;
      }

      return 5 + (progress.completedMarks / progress.totalMarks) * 95;
    }),
  );
}
